<template>
  <section class="container">
    <h1 class="mb-1e is-size-3">Import z TerritoryHelper:</h1>

    <div class="textarea-wrapper">
      <div class="field">
        <label class="label">Wklej dane z pliku:</label>
        <div class="control">
          <textarea class="textarea" rows="10" v-model="textData"></textarea>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button
            type="button"
            class="button"
            @click.prevent="convertData">
            Konwertuj
          </button>
        </div>
        <div class="control" v-if="isConverted">
          <button
            type="button"
            class="button is-success"
            @click.prevent="exportData">
            Zapisz
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { uuid } from '@/utils';
import { saveData } from '@/api';

export default {
  data: () => ({
    textData: '',
    isConverted: false,
    th: {},
    shapes: [],
    conv: {},
  }),
  computed: {
    ...mapState([
      'settings',
      'mapTypes',
    ]),
  },
  methods: {
    ...mapMutations({
      initStore: 'INITIALISE_STORE',
    }),
    convertToJSON() {
      let isJson = false;
      let json = {};

      try {
        json = JSON.parse(this.textData);
        isJson = true;
      } catch (e) {
        console.warn('JSON import error', e); // eslint-disable-line
        isJson = false;
      }

      if (isJson) {
        this.th = {
          ...this.th,
          ...json.features,
        };

        json = json.features;

        Object.keys(json).forEach((key) => {
          const { geometry, properties } = json[key];
          this.calculateEach(geometry, properties);
        });
      }
    },
    getCenter(arr) {
      const { length } = arr;
      let twoTimesSignedArea = 0;
      let cxTimes6SignedArea = 0;
      let cyTimes6SignedArea = 0;

      const x = i => arr[i % length][0];
      const y = i => arr[i % length][1];

      arr.forEach((elem, i) => {
        const twoSA = x(i) * y(i + 1) - x(i + 1) * y(i);

        twoTimesSignedArea += twoSA;
        cxTimes6SignedArea += (x(i) + x(i + 1)) * twoSA;
        cyTimes6SignedArea += (y(i) + y(i + 1)) * twoSA;
      });

      const sixSignedArea = 3 * twoTimesSignedArea;

      return {
        lng: cxTimes6SignedArea / sixSignedArea,
        lat: cyTimes6SignedArea / sixSignedArea,
      };
    },
    convertPolygons(uid, coordinates) {
      const shapes = [];

      coordinates.forEach((shapeArr) => {
        const shape = shapeArr.map(arr => ({
          lng: arr[0],
          lat: arr[1],
        }));

        shapes.push(shape);
      });

      return shapes;
    },
    calculateEach(geometry, properties) {
      const uid = uuid();
      const { coordinates } = geometry;
      const {
        name,
        description,
        TerritoryNotes: additional,
      } = properties;

      const id = name.replace(/[\W_]+/g, '-');

      this.$set(this.conv, uid, {
        id,
        name: description,
        size: '',
        map: {
          center: this.getCenter(coordinates[0]),
          shapes: this.convertPolygons(uid, coordinates),
          zoom: 17,
        },
        additional,
      });
    },
    convertData() {
      this.convertToJSON();

      this.isConverted = true;
      this.textData = JSON.stringify(this.conv, null, 2);
    },
    exportData() {
      const data = {
        hs: {},
        nv: {},
        settings: this.settings,
        tr: this.conv,
        mapTypes: this.mapTypes,
      };

      this.textData = '';
      saveData(data);
      this.initStore();
    },
  },
};
</script>
